import React from "react"
import BasePage from "../base"
import { css, StyleSheet } from "aphrodite"
import {
  getValueFromObjectByKeys,
  translate
} from "../../helper"
import TextBase from "../../common/text"
import PageTitleHeader from "../../common/page-title-header"
import { Colors } from "../../themes/Colors"
import {animate, sizeOfBaseButton} from "../../utils/defined"

import { connect } from "react-redux"
import withNavigate from "../../component/WithNavigate"
import { Row } from "antd"
import { SVGImageComponentReact } from "../../themes/Images"
import {motion} from "framer-motion";
import APIManager from "../../connection/ApiManager";

const heightOfBottomBlackAlpha = `calc(var(--fs-hero)*6.69)`

const styles = StyleSheet.create({
  container: {
    textAlign: "left",
    position: "relative",
    overflowY: "auto",
    overflowX: "hidden",
    padding: 'calc(var(--sp-lg)*1.5) calc(var(--sp-lg)*1.6) calc(var(--sp-lg)*8)',
    backgroundColor: Colors.content_page,
    overflow: 'none'
  },
  dashboardTitle: {
    marginBottom:  'calc(var(--sp-lg)*2.4528)',
    marginTop: 'calc(var(--sp-lg)*2.3584)'
  },
  bottomBlackAlpha: {
    width: "100%",
    minWidth: "100vw",
    height: heightOfBottomBlackAlpha,
    backgroundColor: Colors.black80,
    bottom: 0,
    left: 0,
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    flexDirection: "column",
    zIndex: 1,
    position: "absolute"
  },
  bgOverlay: {
    width: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    background:
        "linear-gradient(90deg, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0.56) 100%)",
    zIndex: 1,
    overflow: "hidden"
  },
  wrapText: {
    position: "relative",
    zIndex: 4,
    maxWidth: "50%",
    height: "100%",
    minHeight: `calc(var(--fs-hero)*9.4339)`,
    paddingLeft: `calc(var(--fs-hero)*2.3584)`
  },
  buttonAction: {
    width: sizeOfBaseButton.width,
    height: sizeOfBaseButton.height,
    marginBottom: `calc(var(--sp-lg)*1.5566)`
  },
  flex: {
    display: 'flex',
    justifyContent: 'space-between'
  }
})

class Privacy extends BasePage {
  constructor(props) {
    super(props)
    this.title = "Settings"
    this.state = {
      terms: ''
    }
  }

  componentDidMount() {
    this.fetchTerms()
  }

  async fetchTerms () {
    const { data } = await APIManager.getInstance().getPrivacy()
    const terms = data[0]?.body
    this.setState({
      privacy: terms
    })
  }

  createMarkup() {
    return { __html: this.state.privacy };
  }

  renderContent() {
    const { navigate } = this.props
    return (
        <motion.div
            initial={animate.initial}
            animate={animate.animate}
            transition={animate.transition}
        >
          <div className={css(styles.container)}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 'calc(var(--sp-md2)*1.132)' }}>
              <div className="flex-row-center-center cursor-pointer" onClick={() => navigate(-1)}>
                <SVGImageComponentReact.IconArrowBack style={{width:"var(--fs-lg)", height:"var(--fs-lg)", color: '#1A5A78'}}/>
              </div>
              <PageTitleHeader
                title={translate('privacyPolicy')}
                showBar={false}
              />
            </div>
            <Row style={{ marginTop: 'var(--sp-md2)' }}>
              <div style={{ padding: 'calc(var(--sp-lg)*1.415)', height: '80vh', overflow: 'auto' }}>
                <div dangerouslySetInnerHTML={this.createMarkup()}>

                </div>
              </div>
            </Row>
          </div>

        </motion.div>
    )
  }
}

const mapStateToProps = state => {
  return {
    userDetail: getValueFromObjectByKeys(state, ["User", "userDetail"]),
    userInfo: getValueFromObjectByKeys(state, ["User", "userInfo"]),
    listNotification: getValueFromObjectByKeys(state, ["User", "notification"])
  }
}
const mapDispatchToProps = dispatch => {
  return {}
}
export default connect(mapStateToProps, mapDispatchToProps)(withNavigate(Privacy))
